import { Component, OnInit, Input, inject } from '@angular/core';
import { VoiceProduct } from '@shared/models/voice-product.model';
import { select, Store } from '@ngxs/store';
import {
  ApiGetSubscriptionServicesAction,
  ApiGetSubscriptionOfferingsAction,
  ApiGetSubscriberForVoiceSubscriptionAction,
} from '@sales/states/customer-product/customer-product.actions';
import { IconNames } from '@shared/enums/icon-names';
import { OfferingSelectors } from '@sales/states/offering/offering.selectors';
import { SubscriptionHelperService } from '@sales/services/subscription-helper.service';
import { CustomerProductMobilePhoneSelectors } from '@sales/states/customer-product-mobilephone/customer-product-mobilephone.selectors';
import { Subscription } from 'rxjs';
import { MobilePaymentType } from '@sales/enums/mobile-payment-type';
import { AdditionalServiceVoice, ServiceStatus } from '../../models/additional-service-voice.model';
import { SubscriptionStatus } from '@app/shared/models/subscription-model';
import { PriceType } from '@app/shared/pipes/price-format.pipe';
import { PcmProduct } from '../../models/pcm-product.model';
import { OfferingHelperService } from '@app/sales/services/offering-helper.service';
import { PriceFormatPipe } from '@app/shared/pipes/price-format.pipe';
import { DatePipe } from '@angular/common';
import { ChangeSimCardComponent } from './change-sim-card/change-sim-card.component';
import { ChangeUserComponent } from './change-user/change-user.component';

import { ChangeSubscriptionComponent } from './change-subscription/change-subscription.component';
import { MatTooltip } from '@angular/material/tooltip';
import { SmallCardButtonComponent } from '@app/shared/components/atoms/small-card-button/small-card-button.component';
import { IcePillComponent } from '@app/shared/components/atoms/ice-pill/ice-pill.component';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { ChangeAdditionalServices } from '@app/sales/modules/subscription/components/existing-subscription/change-additional-services/change-additional-services.component';

@Component({
  selector: 'app-existing-subscription',
  templateUrl: './existing-subscription.component.html',
  styleUrls: ['./existing-subscription.component.scss'],
  imports: [
    SpinnerComponent,
    IcePillComponent,
    SmallCardButtonComponent,
    MatTooltip,
    ChangeSubscriptionComponent,
    ChangeUserComponent,
    ChangeSimCardComponent,
    DatePipe,
    PriceFormatPipe,
    ChangeAdditionalServices,
  ],
})
export class ExistingSubscriptionComponent implements OnInit {
  private store = inject(Store);

  IconNames = IconNames;
  ServiceStatus = ServiceStatus;
  PriceType = PriceType;

  @Input() product: VoiceProduct;

  isLoadingAdditionalServiceOfferings = select(OfferingSelectors.isLoadingAdditionalServicesForOffering);
  allMobileProducts = select(CustomerProductMobilePhoneSelectors.mobilePhoneProducts);

  isChangingSubscription = false;
  isAddingAdditionalServices = false;
  isChangingUser = false;
  isChangingSimCard = false;
  isOfferingUpgradeDisabled = false;
  isChangeUserDisabled = false;
  isAddAdditionalServicesDisabled = false;
  isReplacementSimDisabled = false;
  SubscriptionNotActiveTooltip = 'Kan ikke endres før abonnementet er aktivt';
  ReplacementSimTooltip = 'Kan ikke bestille erstatnings-SIM når abonnementet er under portering';
  subscriptions$: Subscription[] = [];

  SubscriptionStatus = SubscriptionStatus;
  VoiceProduct = VoiceProduct;

  ngOnInit() {
    if (!this.product.subscriptionServices) {
      this.store.dispatch(new ApiGetSubscriptionServicesAction(+this.product.subscription.id));
    }
    if (!this.product.existingSubscriber) {
      this.store.dispatch(new ApiGetSubscriberForVoiceSubscriptionAction(this.product.subscription.id));
    }

    if (this.product.accessoryProductId) {
      this.isOfferingUpgradeDisabled = true;
    }

    if (this.product.mobileProductId) {
      const mobileProduct = this.allMobileProducts().find(m => m.id === this.product.mobileProductId);
      if (mobileProduct?.paymentType === MobilePaymentType.PayNowWithSubscription) this.isOfferingUpgradeDisabled = true;
    }

    if (this.product.subscription.status !== SubscriptionStatus.Active) {
      this.isOfferingUpgradeDisabled = true;
      this.isChangeUserDisabled = true;
      this.isAddAdditionalServicesDisabled = true;
      this.isReplacementSimDisabled = true;
    }
  }

  changeSubscription(product: VoiceProduct) {
    this.isChangingSubscription = true;
    if (!product.allowedSubscriptionOfferings || product.allowedSubscriptionOfferings.length === 0) {
      this.store.dispatch(new ApiGetSubscriptionOfferingsAction(product.subscription.id));
    }
  }

  onAddAdditionalServices() {
    this.isAddingAdditionalServices = true;
  }

  onAddAdditionalServicesClose() {
    this.isAddingAdditionalServices = false;
  }

  onChangeSubscriptionUser() {
    this.isChangingUser = true;
  }

  onChangeUserClose() {
    this.isChangingUser = false;
  }

  onChangeSubscriptionClose() {
    this.isChangingSubscription = false;
  }

  onChangeSimCard() {
    this.isChangingSimCard = true;
  }

  onChangeSimCardClose() {
    this.isChangingSimCard = false;
  }

  get assignedVasProduct(): PcmProduct {
    return OfferingHelperService.mapFromVasAddonToVasProduct(VoiceProduct.vasAddon(this.product));
  }

  getActiveAndSuspendedServices(): AdditionalServiceVoice[] {
    return [
      ...SubscriptionHelperService.getActiveServices(this.product.originalSubscriptionServices),
      ...SubscriptionHelperService.getSuspendedServices(this.product.originalSubscriptionServices),
    ];
  }
}
